const TRACKER_URL_RE = /(?:https?:\/\/)?tracker\.yandex\.ru\/([A-Za-z][\w-]*-\d+)/;

/**
 * If the input is (or contains) a Yandex Tracker URL, returns the task key.
 * Otherwise returns the input unchanged.
 */
export const extractTaskKeyFromUrl = (input: string): string => {
  const match = input.match(TRACKER_URL_RE);

  return match ? match[1] : input;
};
